(() => {
  'use strict';

  const PERIOD_ORDER = [
    { id: 'late_night', label: 'Late Night', range: '12:00 AM - 5:00 AM', icon: 'moon' },
    { id: 'dawn', label: 'Dawn', range: '5:00 AM - 7:00 AM', icon: 'sunrise' },
    { id: 'morning', label: 'Morning', range: '7:00 AM - 10:00 AM', icon: 'sun' },
    { id: 'late_morning', label: 'Late Morning', range: '10:00 AM - 12:00 PM', icon: 'sunrise' },
    { id: 'afternoon', label: 'Afternoon', range: '12:00 PM - 3:00 PM', icon: 'sun' },
    { id: 'late_afternoon', label: 'Late Afternoon', range: '3:00 PM - 6:00 PM', icon: 'sunset' },
    { id: 'evening', label: 'Evening', range: '6:00 PM - 9:00 PM', icon: 'sunset' },
    { id: 'nightfall', label: 'Nightfall', range: '9:00 PM - 12:00 AM', icon: 'moon' }
  ];

  // DEMO DATA ONLY — not sourced from the live BirdMic journal.
  const DEMO_DATA = {
    schema_version: 1,
    date: '2026-07-15',
    timezone: 'America/Chicago',
    generated_at: '2026-07-15T09:05:00-05:00',
    current_period: 'morning',
    day_status: 'observing',
    next_update_at: '2026-07-15T09:15:00-05:00',
    periods: [
      {
        id: 'late_night',
        label: 'Late Night',
        time_range: '12:00 AM - 5:00 AM',
        status: 'complete',
        completed_hours: ['12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM'],
        expected_hours: ['12:00 AM', '1:00 AM', '2:00 AM', '3:00 AM', '4:00 AM'],
        display_text_source: 'fallback',
        display_text: 'The late-night demo record stays quiet and humid, with Common True Katydid, Rio Grande Chirping Frog, and Lyric Cicada notes carrying beyond the ridge. These sample notes show how a completed period will read once live journal data is connected.',
        live_text: 'Late-night notes are complete.',
        final_text: 'The late-night demo record stays quiet and humid, with Common True Katydid, Rio Grande Chirping Frog, and Lyric Cicada notes carrying beyond the ridge. These sample notes show how a completed period will read once live journal data is connected.',
        hourly_entries: [
          { hour: '12:00 AM', status: 'complete', text: 'A mostly quiet sample hour holds Common True Katydid calls and steady humidity under cloud cover.', species: ['Common True Katydid'], weather_cues: ['Humid'] },
          { hour: '1:00 AM', status: 'complete', text: 'Rio Grande Chirping Frog calls give the demo record a sparse, damp understory pattern.', species: ['Rio Grande Chirping Frog'], weather_cues: ['Still air'] },
          { hour: '2:00 AM', status: 'complete', text: 'Lyric Cicada notes carry the sample soundscape while the woods stay otherwise restrained.', species: ['Lyric Cicada'], weather_cues: ['No rain'] },
          { hour: '3:00 AM', status: 'complete', text: 'Common True Katydid remains the clearest named voice in this demonstration hour.', species: ['Common True Katydid'], weather_cues: ['Humid'] },
          { hour: '4:00 AM', status: 'complete', text: 'The demo record edges toward dawn as Carolina Wren notes begin to appear.', species: ['Carolina Wren'], weather_cues: ['Pre-dawn'] }
        ],
        period_summary: {
          detection_count: 18,
          species_count: 6,
          weather: {
            humidity_label: 'Heavy',
            humidity_percent: 91,
            wind_label: 'Calm',
            wind_direction: 'S',
            wind_speed_mph: 1,
            rain_label: 'No rain',
            rain_inches: 0,
            daylight_label: 'Dark'
          },
          voices: [
            { common_name: 'Common True Katydid', count: 9 },
            { common_name: 'Rio Grande Chirping Frog', count: 4 },
            { common_name: 'Lyric Cicada', count: 3 },
            { common_name: 'Carolina Wren', count: 2 }
          ]
        }
      },
      {
        id: 'morning',
        label: 'Morning',
        time_range: '7:00 AM - 10:00 AM',
        status: 'observing',
        completed_hours: ['7:00 AM', '8:00 AM'],
        expected_hours: ['7:00 AM', '8:00 AM', '9:00 AM', '10:00 AM'],
        display_text_source: 'live',
        display_text: '',
        live_text: 'The morning journal is still being written from structured hourly observations.',
        final_text: '',
        hourly_entries: [
          {
            hour: '7:00 AM',
            status: 'complete',
            text: 'The woods stirred into a bright, humid morning. Carolina Wren and White-eyed Vireo notes carried through the canopy while the air stayed cool and damp after overnight moisture.',
            species: ['Carolina Wren', 'White-eyed Vireo', 'Hooded Warbler'],
            weather_cues: ['Humid', 'Light wind', 'No rain']
          },
          {
            hour: '8:00 AM',
            status: 'complete',
            text: 'Sunlight strengthened quickly and the forest became more active. Hooded Warbler, Northern Cardinal, and Blue Jay voices moved through the midstory in short bursts.',
            species: ['Hooded Warbler', 'Northern Cardinal', 'Blue Jay'],
            weather_cues: ['Humid', 'Light wind']
          },
          {
            hour: '9:00 AM',
            status: 'observing',
            text: '',
            species: [],
            weather_cues: []
          },
          {
            hour: '10:00 AM',
            status: 'upcoming',
            text: '',
            species: [],
            weather_cues: []
          }
        ],
        period_summary: {
          detection_count: 31,
          species_count: 14,
          sunrise: '6:23 AM',
          weather: {
            humidity_label: 'Heavy',
            humidity_percent: 90,
            wind_label: 'Light',
            wind_direction: 'S',
            wind_speed_mph: 3,
            rain_label: 'No rain',
            rain_inches: 0,
            daylight_label: 'Strengthening'
          },
          voices: [
            { common_name: 'Carolina Wren', count: 12 },
            { common_name: 'White-eyed Vireo', count: 9 },
            { common_name: 'Hooded Warbler', count: 7 },
            { common_name: 'Northern Cardinal', count: 6 },
            { common_name: 'Blue Jay', count: 4 },
            { common_name: 'Summer Tanager', count: 3 }
          ]
        }
      },
      {
        id: 'late_morning',
        label: 'Late Morning',
        time_range: '10:00 AM - 12:00 PM',
        status: 'upcoming',
        completed_hours: [],
        expected_hours: ['10:00 AM', '11:00 AM'],
        hourly_entries: [],
        display_text: '',
        period_summary: {}
      },
      {
        id: 'afternoon',
        label: 'Afternoon',
        time_range: '12:00 PM - 3:00 PM',
        status: 'upcoming',
        completed_hours: [],
        expected_hours: ['12:00 PM', '1:00 PM', '2:00 PM'],
        hourly_entries: [],
        display_text: '',
        period_summary: {}
      },
      {
        id: 'late_afternoon',
        label: 'Late Afternoon',
        time_range: '3:00 PM - 6:00 PM',
        status: 'upcoming',
        completed_hours: [],
        expected_hours: ['3:00 PM', '4:00 PM', '5:00 PM'],
        hourly_entries: [],
        display_text: '',
        period_summary: {}
      },
      {
        id: 'evening',
        label: 'Evening',
        time_range: '6:00 PM - 9:00 PM',
        status: 'upcoming',
        completed_hours: [],
        expected_hours: ['6:00 PM', '7:00 PM', '8:00 PM'],
        hourly_entries: [],
        display_text: '',
        period_summary: {}
      },
      {
        id: 'nightfall',
        label: 'Nightfall',
        time_range: '9:00 PM - 12:00 AM',
        status: 'upcoming',
        completed_hours: [],
        expected_hours: ['9:00 PM', '10:00 PM', '11:00 PM'],
        hourly_entries: [],
        display_text: '',
        period_summary: {}
      },
      {
        id: 'dawn',
        label: 'Dawn',
        time_range: '5:00 AM - 7:00 AM',
        status: 'complete',
        completed_hours: ['5:00 AM', '6:00 AM'],
        expected_hours: ['5:00 AM', '6:00 AM'],
        display_text_source: 'model',
        display_text: 'Dawn opened with a short rise in song as the ridge brightened. Wrens, cardinals, and vireos shaped the first clear passage of the day while humidity remained heavy near the ground.',
        live_text: 'Dawn notes were captured hour by hour.',
        final_text: 'Dawn opened with a short rise in song as the ridge brightened. Wrens, cardinals, and vireos shaped the first clear passage of the day while humidity remained heavy near the ground.',
        hourly_entries: [
          { hour: '5:00 AM', status: 'complete', text: 'The first bird notes arrived before sunrise, light but steady.', species: ['Northern Cardinal', 'Carolina Wren'], weather_cues: ['Dark', 'Humid'] },
          { hour: '6:00 AM', status: 'complete', text: 'Activity gathered around sunrise as wrens and vireos became easier to hear.', species: ['Carolina Wren', 'White-eyed Vireo'], weather_cues: ['Sunrise', 'Humid'] }
        ],
        period_summary: {
          detection_count: 24,
          species_count: 9,
          weather: {
            humidity_label: 'Heavy',
            humidity_percent: 92,
            wind_label: 'Light',
            wind_direction: 'S',
            wind_speed_mph: 2,
            rain_label: 'No rain',
            rain_inches: 0,
            daylight_label: 'Rising'
          },
          voices: [
            { common_name: 'Carolina Wren', count: 8 },
            { common_name: 'Northern Cardinal', count: 6 },
            { common_name: 'White-eyed Vireo', count: 5 }
          ]
        }
      }
    ]
  };

  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const escapeHtml = value => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');
  const PUBLIC_AUDIO_BASE_URL = 'https://pub-ead7f6590ab5448e9c1ed42230f2bd83.r2.dev/';
  const SPECIES_IMAGE_DATA_URL = 'https://wpc-wildlife-live.jbmanning5.workers.dev/dashboard.json';
  let speciesImageLookupPromise = null;

  function isPlayableUrl(value) {
    return /^https?:\/\//i.test(String(value || '').trim());
  }

  function resolveAudioUrl(value) {
    const trimmed = String(value || '').trim();
    if (!trimmed) return '';
    if (isPlayableUrl(trimmed)) return trimmed;
    return `${PUBLIC_AUDIO_BASE_URL}${trimmed.replace(/^\/+/, '')}`;
  }

  function imageLookupKey(value) {
    return String(value || '').trim().toLowerCase();
  }

  function validSpeciesImage(value) {
    return typeof value === 'string' && value.startsWith('data:image/') && value.includes(';base64,');
  }

  function addSpeciesImageCandidate(lookup, item) {
    const source = item?.thumbnailDataUri || item?.thumbnail_data_uri || '';
    if (!validSpeciesImage(source)) return;
    const scientific = imageLookupKey(item.scientificName || item.scientific_name);
    const common = imageLookupKey(item.commonName || item.common_name || item.species);
    if (scientific && !lookup.byScientific.has(scientific)) lookup.byScientific.set(scientific, source);
    if (common && !lookup.byCommon.has(common)) lookup.byCommon.set(common, source);
  }

  function collectSpeciesImages(value, lookup) {
    if (Array.isArray(value)) {
      value.forEach(item => collectSpeciesImages(item, lookup));
      return;
    }
    if (!value || typeof value !== 'object') return;
    addSpeciesImageCandidate(lookup, value);
    Object.values(value).forEach(item => {
      if (item && typeof item === 'object') collectSpeciesImages(item, lookup);
    });
  }

  function loadSpeciesImageLookup() {
    if (!speciesImageLookupPromise) {
      speciesImageLookupPromise = fetch(`${SPECIES_IMAGE_DATA_URL}?t=${Date.now()}`, { cache: 'no-store' })
        .then(response => {
          if (!response.ok) throw new Error(`Status ${response.status}`);
          return response.json();
        })
        .then(data => {
          const lookup = { byScientific: new Map(), byCommon: new Map() };
          collectSpeciesImages(data, lookup);
          return lookup;
        })
        .catch(() => ({ byScientific: new Map(), byCommon: new Map() }));
    }
    return speciesImageLookupPromise;
  }

  function resolveSpeciesImage(voice, lookup) {
    const existing = voice.thumbnail_url || voice.thumbnailUrl || voice.imageUrl || voice.thumbnailDataUri || '';
    if (validSpeciesImage(existing) || /^https?:\/\//i.test(existing)) return existing;
    const scientific = imageLookupKey(voice.scientific_name || voice.scientificName);
    if (scientific && lookup?.byScientific?.has(scientific)) return lookup.byScientific.get(scientific);
    const common = imageLookupKey(voice.common_name || voice.commonName || voice.name);
    if (common && lookup?.byCommon?.has(common)) return lookup.byCommon.get(common);
    return '';
  }

  function voicePlaybackState(root) {
    if (!root._fieldJournalPlayback) {
      root._fieldJournalPlayback = {
        audio: null,
        button: null,
        url: ''
      };
    }
    return root._fieldJournalPlayback;
  }

  function voiceButtonLabel(status, name) {
    if (status === 'loading') return `Loading ${name} audio`;
    if (status === 'playing') return `Pause ${name} audio`;
    if (status === 'paused') return `Resume ${name} audio`;
    if (status === 'error') return `Retry ${name} audio`;
    return `Play ${name} audio`;
  }

  function syncVoiceButton(button, status, name) {
    if (!button) return;
    button.classList.toggle('is-loading', status === 'loading');
    button.classList.toggle('is-playing', status === 'playing');
    button.classList.toggle('is-paused', status === 'paused');
    button.classList.toggle('is-error', status === 'error');
    button.setAttribute('aria-label', voiceButtonLabel(status, name));
    button.setAttribute('aria-pressed', String(status === 'playing'));
    button.textContent = status === 'loading' ? '…' : status === 'playing' ? '❚❚' : status === 'error' ? '!' : '▶';
  }

  function stopVoicePlayback(root) {
    const state = voicePlaybackState(root);
    const { audio, button } = state;
    state.audio = null;
    state.button = null;
    state.url = '';
    if (audio) {
      audio.pause();
      audio.currentTime = 0;
      audio.removeAttribute('src');
      audio.load();
    }
    if (button) {
      syncVoiceButton(button, 'idle', button.dataset.fjAudioName || 'Wildlife');
    }
  }

  function handleVoiceAudioClick(event, root) {
    const button = event.target.closest('[data-fj-audio-url]');
    if (!button) return;

    const clipUrl = button.dataset.fjAudioUrl || '';
    if (!clipUrl) return;

    event.preventDefault();

    const name = button.dataset.fjAudioName || 'Wildlife';
    const state = voicePlaybackState(root);

    if (state.audio && state.button === button && state.url === clipUrl) {
      if (state.audio.paused) {
        syncVoiceButton(button, 'loading', name);
        state.audio.play().catch(() => {
          syncVoiceButton(button, 'error', name);
          window.setTimeout(() => syncVoiceButton(button, 'idle', name), 1200);
          state.audio = null;
          state.button = null;
          state.url = '';
        });
      } else {
        state.audio.pause();
      }
      return;
    }

    stopVoicePlayback(root);

    const audio = new Audio(clipUrl);
    state.audio = audio;
    state.button = button;
    state.url = clipUrl;

    syncVoiceButton(button, 'loading', name);

    audio.addEventListener('playing', () => {
      if (state.audio !== audio || state.button !== button) return;
      syncVoiceButton(button, 'playing', name);
    });

    audio.addEventListener('pause', () => {
      if (state.audio !== audio || state.button !== button || audio.ended) return;
      syncVoiceButton(button, 'paused', name);
    });

    audio.addEventListener('ended', () => {
      if (state.audio !== audio || state.button !== button) return;
      state.audio = null;
      state.button = null;
      state.url = '';
      syncVoiceButton(button, 'idle', name);
    });

    audio.addEventListener('error', () => {
      if (state.audio !== audio || state.button !== button) return;
      state.audio = null;
      state.button = null;
      state.url = '';
      syncVoiceButton(button, 'error', name);
      window.setTimeout(() => syncVoiceButton(button, 'idle', name), 1200);
    });

    audio.play().catch(() => {
      if (state.audio !== audio || state.button !== button) return;
      state.audio = null;
      state.button = null;
      state.url = '';
      syncVoiceButton(button, 'error', name);
      window.setTimeout(() => syncVoiceButton(button, 'idle', name), 1200);
    });
  }

  function icon(name) {
    if (name === 'moon') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.7 15.5A8.3 8.3 0 0 1 8.5 5.3a7.6 7.6 0 1 0 10.2 10.2Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
    }
    if (name === 'sunrise' || name === 'sunset') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 17h16M6 13a6 6 0 0 1 12 0M12 3v4M4.9 6.9l2.8 2.8M19.1 6.9l-2.8 2.8M8 21h8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3M5.3 5.3l2.1 2.1M16.6 16.6l2.1 2.1M18.7 5.3l-2.1 2.1M7.4 16.6l-2.1 2.1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  }

  function weatherIcon(index) {
    const icons = [
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3c2.8 3.4 5 6.4 5 9.1a5 5 0 0 1-10 0C7 9.4 9.2 6.4 12 3Z" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M9.5 14.2c.6 1.2 1.4 1.8 2.5 1.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h9.5a3 3 0 1 0-2.9-3.7M5 17h12a2.5 2.5 0 1 1-2.4 3.1M4 7h4.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.5 16.5h10a4 4 0 0 0-.9-7.9A5.8 5.8 0 0 0 4.9 10.7a3 3 0 0 0 1.6 5.8Z" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M8 20v1M12 19v1M16 20v1" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
      icon('sun')
    ];
    return icons[index] || icon('sun');
  }

  function formatDateTime(value, timezone, options = {}) {
    if (!value) return '--';
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) return String(value);
    return new Intl.DateTimeFormat('en-US', {
      timeZone: timezone || 'America/Chicago',
      hour: 'numeric',
      minute: '2-digit',
      ...options
    }).format(date);
  }

  function canonicalPeriodId(value) {
    return String(value || '').replaceAll('_', '-');
  }

  function samePeriodId(left, right) {
    return canonicalPeriodId(left) === canonicalPeriodId(right);
  }

  function formatHourValue(value, timezone, fallbackDateTime = '') {
    if (fallbackDateTime) return formatDateTime(fallbackDateTime, timezone);
    if (typeof value === 'number' && Number.isFinite(value)) {
      const hour = ((value % 24) + 24) % 24;
      const displayHour = hour % 12 || 12;
      return `${displayHour}:00 ${hour < 12 ? 'AM' : 'PM'}`;
    }
    if (typeof value === 'string' && /^-?\d+$/.test(value.trim())) {
      return formatHourValue(Number(value), timezone);
    }
    return String(value ?? 'Hour');
  }

  function formatPeriodRange(raw, fallback, timezone) {
    const start = raw?.start_local || raw?.startLocal;
    const end = raw?.end_local || raw?.endLocal;
    if (start && end) {
      const startDate = new Date(start);
      const endDate = new Date(end);
      if (Number.isFinite(startDate.getTime()) && Number.isFinite(endDate.getTime())) {
        return `${formatDateTime(start, timezone)} - ${formatDateTime(end, timezone)}`;
      }
    }
    return raw?.time_range || raw?.timeRange || fallback.range;
  }

  function validHourValue(value) {
    return value !== undefined && value !== null && value !== '';
  }

  function hourKey(value) {
    return String(value);
  }

  function normalizeEntry(raw, timezone) {
    const hour = raw?.hour;
    const explicitStatus = raw?.status || '';
    return {
      ...raw,
      hour,
      hourLabel: formatHourValue(hour, timezone, raw?.window_start_local || raw?.windowStartLocal),
      windowStartLocal: raw?.window_start_local || raw?.windowStartLocal || '',
      windowEndLocal: raw?.window_end_local || raw?.windowEndLocal || '',
      generationSource: raw?.generation_source || raw?.generationSource || '',
      hasExplicitStatus: Boolean(explicitStatus),
      status: explicitStatus || (validHourValue(hour) ? 'complete' : 'upcoming'),
      text: raw?.text || ''
    };
  }

  function paragraphHtml(text) {
    return String(text || '')
      .split(/\n{2,}/)
      .map(part => part.trim())
      .filter(Boolean)
      .map(part => `<p>${escapeHtml(part).replace(/\n/g, '<br>')}</p>`)
      .join('');
  }

  function statusLabel(status) {
    const labels = {
      observing: 'Live',
      finalizing: 'Finalizing',
      complete: 'Complete',
      incomplete: 'Incomplete record',
      upcoming: 'Upcoming'
    };
    return labels[status] || 'Unavailable';
  }

  function sourceLabel(value) {
    if (typeof value === 'string') return value.trim();
    if (!value || typeof value !== 'object') return '';

    const exactName = value.common_name || value.commonName || value.species_common_name || value.speciesCommonName || value.name;
    if (exactName) return String(exactName).trim();

    const group = String(value.group || value.category || value.organism_type || value.organismType || '').toLowerCase();
    if (group.includes('insect')) return 'Unidentified insect activity';
    if (group.includes('frog') || group.includes('amphibian')) return 'Unidentified frog calls';
    if (group.includes('bird')) return 'Unidentified bird calls';
    return '';
  }

  function sourceLabels(items) {
    return (Array.isArray(items) ? items : [])
      .map(sourceLabel)
      .filter(Boolean);
  }

  function normalizePeriod(raw, fallback, timezone) {
    const id = raw?.id || raw?.period || fallback.id;
    const entries = (Array.isArray(raw?.hourly_entries) ? raw.hourly_entries : (raw?.hourlyEntries || []))
      .map(entry => normalizeEntry(entry, timezone));
    const validEntries = entries.filter(entry => validHourValue(entry.hour));
    const usesExplicitEntryStatus = validEntries.some(entry => entry.hasExplicitStatus);
    return {
      id,
      label: raw?.label || fallback.label,
      range: formatPeriodRange(raw, fallback, timezone),
      status: raw?.status || 'upcoming',
      completedHours: Array.isArray(raw?.completed_hours) ? raw.completed_hours : (raw?.completedHours || []),
      expectedHours: Array.isArray(raw?.expected_hours) ? raw.expected_hours : (raw?.expectedHours || []),
      displayText: raw?.display_text || raw?.displayText || '',
      displayTextSource: raw?.display_text_source || raw?.displayTextSource || '',
      liveText: raw?.live_text || raw?.liveText || '',
      finalText: raw?.final_text || raw?.finalText || '',
      entries,
      validEntries,
      writtenEntries: usesExplicitEntryStatus
        ? validEntries.filter(entry => entry.status === 'complete')
        : validEntries,
      summary: raw?.period_summary || raw?.periodSummary || {}
    };
  }

  function adaptData(payload) {
    const rawPeriods = Array.isArray(payload?.periods) ? payload.periods : [];
    const timezone = payload?.timezone || 'America/Chicago';
    const periodMap = new Map();
    rawPeriods.forEach(period => {
      const id = period?.id || period?.period;
      if (!id) return;
      periodMap.set(String(id), period);
      periodMap.set(canonicalPeriodId(id), period);
    });
    const periods = PERIOD_ORDER.map(fallback => {
      const raw = periodMap.get(fallback.id) || periodMap.get(canonicalPeriodId(fallback.id));
      return normalizePeriod(raw, fallback, timezone);
    });
    const payloadCurrent = payload?.current_period || payload?.currentPeriod || '';
    const currentPeriod = periods.find(period => samePeriodId(period.id, payloadCurrent))?.id
      || periods.find(period => period.status === 'observing')?.id
      || periods[0].id;

    return {
      date: payload?.date || '',
      timezone,
      generatedAt: payload?.generated_at || payload?.generatedAt || payload?.updatedAt || '',
      dayStatus: payload?.day_status || payload?.dayStatus || 'unavailable',
      currentPeriod,
      nextUpdateAt: payload?.next_expected_update_local || payload?.nextExpectedUpdateLocal || payload?.next_update_at || payload?.nextUpdateAt || '',
      periods
    };
  }

  async function getData(root) {
    const url = root.dataset.dataUrl.trim();
    setLoading(root);

    if (!url) {
      return {
        data: adaptData(DEMO_DATA),
        source: 'demo',
        message: 'This page is using sample journal data until a live endpoint is connected.'
      };
    }

    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 7000);
    try {
      const response = await fetch(`${url}${url.includes('?') ? '&' : '?'}t=${Date.now()}`, {
        cache: 'no-store',
        signal: controller.signal
      });
      if (!response.ok) throw new Error(`Status ${response.status}`);
      const data = await response.json();
      return { data: adaptData(data), source: 'endpoint', message: '' };
    } catch (error) {
      return {
        data: adaptData(DEMO_DATA),
        source: 'fallback',
        message: 'The latest journal update is temporarily unavailable. Sample journal data is shown instead.'
      };
    } finally {
      window.clearTimeout(timer);
    }
  }

  function setLoading(root) {
    const entries = $('[data-fj-entries]', root);
    if (entries) {
      entries.innerHTML = '<div class="wpc-field-journal__skeleton"></div><div class="wpc-field-journal__skeleton"></div>';
    }
  }

  function renderTabs(root, state) {
    const host = $('[data-fj-tabs]', root);
    host.innerHTML = state.data.periods.map((period, index) => {
      const fallback = PERIOD_ORDER.find(item => samePeriodId(item.id, period.id)) || PERIOD_ORDER[index] || PERIOD_ORDER[0];
      const selected = samePeriodId(period.id, state.selectedPeriodId);
      return `<button class="wpc-field-journal__period-tab" type="button" role="tab" id="fj-tab-${escapeHtml(period.id)}" aria-selected="${selected}" aria-controls="fj-panel-${escapeHtml(period.id)}" tabindex="${selected ? '0' : '-1'}" data-fj-period="${escapeHtml(period.id)}">${icon(fallback.icon)}<span>${escapeHtml(period.label)}</span></button>`;
    }).join('');

    $$('[data-fj-period]', host).forEach(button => {
      button.addEventListener('click', () => {
        state.selectedPeriodId = button.dataset.fjPeriod;
        render(root, state);
        button.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      });
      button.addEventListener('keydown', event => handleTabKey(event, root, state));
    });
  }

  function renderPeriodSelect(root, state) {
    const select = $('[data-fj-period-select]', root);
    if (!select) return;
    select.innerHTML = state.data.periods.map(period => {
      const selected = samePeriodId(period.id, state.selectedPeriodId) ? ' selected' : '';
      return `<option value="${escapeHtml(period.id)}"${selected}>${escapeHtml(period.label)}</option>`;
    }).join('');
    select.addEventListener('change', () => {
      state.selectedPeriodId = select.value;
      render(root, state);
    });
  }

  function handleTabKey(event, root, state) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    const ids = state.data.periods.map(period => period.id);
    const current = ids.indexOf(state.selectedPeriodId);
    let next = current;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = ids.length - 1;
    if (event.key === 'ArrowLeft') next = current <= 0 ? ids.length - 1 : current - 1;
    if (event.key === 'ArrowRight') next = current >= ids.length - 1 ? 0 : current + 1;
    state.selectedPeriodId = ids[next];
    render(root, state);
    const button = $(`[data-fj-period="${CSS.escape(state.selectedPeriodId)}"]`, root);
    button?.focus();
    button?.scrollIntoView({ inline: 'center', block: 'nearest' });
  }

  function renderHeader(root, state, period) {
    const data = state.data;
    const written = period.writtenEntries.length;
    const expected = period.expectedHours.length || period.validEntries.length;
    $('[data-fj-current-label]', root).textContent = samePeriodId(period.id, data.currentPeriod) ? 'Current period' : 'Selected period';
    $('[data-fj-current-period]', root).textContent = `${period.label} ${period.range}`;
    $('[data-fj-live-status]', root).textContent = statusLabel(period.status);
    $('[data-fj-entry-count]', root).textContent = `${written} of ${expected} written`;
    const nextLabel = nextUpdateLabel(data, period);
    const nextTitle = $('[data-fj-next-update]', root)?.closest('.wpc-field-journal__status-card')?.querySelector('b');
    if (nextTitle) nextTitle.textContent = nextLabel.title;
    $('[data-fj-next-update]', root).textContent = nextLabel.value;
    const sidebarUpdated = $('[data-fj-sidebar-updated]', root);
    if (sidebarUpdated) sidebarUpdated.textContent = data.generatedAt ? formatDateTime(data.generatedAt, data.timezone) : 'Preview data';
    $('[data-fj-timezone]', root).textContent = `All times ${data.timezone.replace('_', ' ')}`;
    $('[data-fj-updated]', root).textContent = data.generatedAt ? `Data updated ${formatDateTime(data.generatedAt, data.timezone)}` : 'Data updated --';
  }

  function nextUpdateLabel(data, period) {
    if (!data.nextUpdateAt) {
      return { title: 'Journal complete', value: 'No further updates today' };
    }
    const title = samePeriodId(period.id, data.currentPeriod) ? 'Next update' : 'Next live update';
    return { title, value: `Around ${formatDateTime(data.nextUpdateAt, data.timezone)}` };
  }

  function renderTimeline(root, period) {
    const host = $('[data-fj-timeline]', root);
    const hours = period.expectedHours.length ? period.expectedHours : period.validEntries.map(entry => entry.hour);
    const entriesByHour = new Map(period.validEntries.map(entry => [hourKey(entry.hour), entry]));
    if (!hours.length) {
      host.innerHTML = '<li class="wpc-field-journal__empty">Hourly notes will appear when this period begins.</li>';
      return;
    }
    host.innerHTML = hours.map(hour => {
      const entry = entriesByHour.get(hourKey(hour));
      const status = entry ? entry.status : 'upcoming';
      const stateClass = stateClassFor(status);
      const label = entry?.hourLabel || formatHourValue(hour);
      return `<li><button type="button" class="wpc-field-journal__timeline-item ${stateClass}" data-fj-scroll-hour="${escapeHtml(hourKey(hour))}"><span class="wpc-field-journal__marker">${status === 'complete' ? '&#10003;' : ''}</span><span class="wpc-field-journal__timeline-copy"><b>${escapeHtml(label)}</b><span>${escapeHtml(statusLabel(status))}</span></span><span aria-hidden="true">&rsaquo;</span></button></li>`;
    }).join('');
    $$('[data-fj-scroll-hour]', $('[data-fj-timeline]', root)).forEach(button => {
      button.addEventListener('click', () => {
        const entry = $(`[data-fj-entry-hour="${CSS.escape(button.dataset.fjScrollHour)}"]`, root);
        entry?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        entry?.focus({ preventScroll: true });
      });
    });
  }

  function renderGlance(root, period) {
    const summary = period.summary || {};
    const weather = summary.weather || {};
    const items = [
      ['Detections so far', summary.detection_count ?? summary.detectionCount],
      ['Species observed', summary.species_count ?? summary.speciesCount],
      ['Weather', weather.humidity_label || weather.humidityLabel ? `${weather.humidity_label || weather.humidityLabel} humidity` : null],
      ['Sunrise', summary.sunrise]
    ].filter(item => item[1] !== undefined && item[1] !== null && item[1] !== '');

    $('[data-fj-glance]', root).innerHTML = items.length
      ? items.map(([label, value]) => `<div><dt>${escapeHtml(label)}</dt><dd>${escapeHtml(value)}</dd></div>`).join('')
      : '<div class="wpc-field-journal__empty">Details for this period are still being prepared.</div>';
  }

  function isFiniteNumber(value) {
    return typeof value === 'number' && Number.isFinite(value);
  }

  function formatNumber(value, digits = 1) {
    if (!isFiniteNumber(value)) return '';
    const rounded = Number(value.toFixed(digits));
    return String(rounded);
  }

  function formatRange(start, end, suffix, digits = 1) {
    if (!isFiniteNumber(start) || !isFiniteNumber(end)) return '';
    return `${formatNumber(start, digits)}${suffix} \u2192 ${formatNumber(end, digits)}${suffix}`;
  }

  function formatWeatherAmount(value, suffix, digits = 1) {
    if (!isFiniteNumber(value)) return '';
    return `${value.toFixed(digits)} ${suffix}`;
  }

  function unavailableWeatherItem(label) {
    return [label, 'Not available', ''];
  }

  function weatherItems(period) {
    const weather = period.summary?.weather || {};
    const hasWeather = Object.keys(weather).length > 0;
    if (!hasWeather) return [];

    const hasLiveWeather = [
      'humidity_summary',
      'wind_summary',
      'rain_summary',
      'daylight_summary',
      'temperature_start_f',
      'humidity_start_pct',
      'wind_speed_avg_mph',
      'rain_total_in'
    ].some(key => Object.prototype.hasOwnProperty.call(weather, key));

    if (!hasLiveWeather) {
      const humidityPercent = weather.humidity_percent ?? weather.humidityPercent;
      const windSpeed = weather.wind_speed_mph ?? weather.windSpeedMph;
      const windDirection = weather.wind_direction || weather.windDirection || '';
      const rainInches = weather.rain_inches ?? weather.rainInches;
      return [
        ['Humidity', weather.humidity_label || weather.humidityLabel || 'Unknown', humidityPercent !== undefined ? `${humidityPercent}%` : 'Awaiting field'],
        ['Wind', weather.wind_label || weather.windLabel || 'Unknown', windSpeed !== undefined ? `${windDirection} ${windSpeed} mph`.trim() : 'Awaiting field'],
        ['Precipitation', weather.rain_label || weather.rainLabel || 'Unknown', rainInches !== undefined || weather.rainInches !== undefined ? `${rainInches} in` : 'Awaiting field'],
        ['Daylight', weather.daylight_label || weather.daylightLabel || 'Unknown', period.range]
      ];
    }

    const humidityDetail = formatRange(weather.humidity_start_pct, weather.humidity_end_pct, '%', 0);
    const windDetail = [
      weather.wind_direction || '',
      isFiniteNumber(weather.wind_speed_avg_mph) ? `${formatNumber(weather.wind_speed_avg_mph)} mph` : ''
    ].filter(Boolean).join(' \u00b7 ');
    const rainDetail = formatWeatherAmount(weather.rain_total_in, 'in', 2);
    const daylightDetail = formatRange(weather.temperature_start_f, weather.temperature_end_f, '\u00b0F', 1);

    return [
      weather.humidity_summary ? ['Humidity', weather.humidity_summary, humidityDetail] : unavailableWeatherItem('Humidity'),
      weather.wind_summary ? ['Wind', weather.wind_summary, windDetail] : unavailableWeatherItem('Wind'),
      weather.rain_summary ? ['Precipitation', weather.rain_summary, rainDetail] : unavailableWeatherItem('Precipitation'),
      weather.daylight_summary ? ['Daylight', weather.daylight_summary, daylightDetail] : unavailableWeatherItem('Daylight')
    ];
  }

  function renderWeather(root, period) {
    const items = weatherItems(period);
    if (!items.length) {
      const html = '<div class="wpc-field-journal__empty">Details for this period are still being prepared.</div>';
      $('[data-fj-weather-strip]', root).innerHTML = html;
      return;
    }
    const html = items.map(([label, value, detail], index) => {
      return `<div class="wpc-field-journal__weather-item"><i aria-hidden="true">${weatherIcon(index)}</i><span><b>${escapeHtml(value)}</b><span>${escapeHtml(label)}${detail ? ` &middot; ${escapeHtml(detail)}` : ''}</span></span></div>`;
    }).join('');
    $('[data-fj-weather-strip]', root).innerHTML = html;
  }

  function renderEntries(root, period) {
    const entriesHost = $('[data-fj-entries]', root);
    const finalHost = $('[data-fj-final]', root);

    entriesHost.hidden = false;

    if (period.status === 'upcoming') {
      entriesHost.innerHTML = `<div class="wpc-field-journal__empty wpc-field-journal__empty--narrative">${escapeHtml(futurePeriodCopy(period))}</div>`;
      finalHost.hidden = true;
      finalHost.innerHTML = '';
      return;
    }

    entriesHost.innerHTML = entriesHtml(period.validEntries);
    const reflection = period.finalText || '';
    finalHost.hidden = !reflection;
    finalHost.innerHTML = reflection
      ? `<details class="wpc-field-journal__reflection"><summary>Read the period reflection</summary><div class="wpc-field-journal__reflection-prose">${paragraphHtml(reflection)}</div></details>`
      : '';
  }

  function futurePeriodCopy(period) {
    const id = canonicalPeriodId(period.id);
    const copy = {
      'late-morning': 'This page remains unwritten. Late morning will add its first note when the hour arrives.',
      afternoon: 'Afternoon has not yet reached the journal. Its weather and voices are still ahead.',
      evening: 'Evening waits beyond the daylight. Its first note will appear after the period begins.',
      nightfall: 'Nightfall remains an unopened page, waiting for the voices that return after dark.'
    };
    return copy[id] || `${period.label} remains an unopened page. Its first note will appear after the period begins.`;
  }

  function entriesHtml(entries) {
    if (!entries.length) {
      return '<div class="wpc-field-journal__empty">Details for this period are still being prepared.</div>';
    }
    return entries.map(entry => {
      const text = entry.text || (entry.status === 'observing' ? 'Observations are unfolding... the next note will appear after this hour closes.' : 'This hour is still awaiting a journal note.');
      const chips = [...sourceLabels(entry.species), ...(entry.weather_cues || entry.weatherCues || [])];
      return `<article class="wpc-field-journal__entry ${stateClassFor(entry.status)}" tabindex="-1" data-fj-entry-hour="${escapeHtml(hourKey(entry.hour))}"><div class="wpc-field-journal__entry-meta"><h3>${escapeHtml(entry.hourLabel || formatHourValue(entry.hour))}</h3><span class="wpc-field-journal__state">${escapeHtml(statusLabel(entry.status))}</span></div><div class="wpc-field-journal__entry-prose">${entry.status === 'observing' && !entry.text ? `<p><em>${escapeHtml(text)}</em></p>` : paragraphHtml(text)}${chips.length ? `<div class="wpc-field-journal__chips">${chips.map(chip => `<span class="wpc-field-journal__chip">${escapeHtml(chip)}</span>`).join('')}</div>` : ''}</div></article>`;
    }).join('');
  }

  function renderVoices(root, period) {
    stopVoicePlayback(root);
    const voices = Array.isArray(period.summary?.voices) ? period.summary.voices : [];
    const quietFind = period.summary?.quiet_find || period.summary?.quietFind || null;
    const imageLookup = root._fieldJournalSpeciesImages || null;
    const cards = voices.slice(0, 5).map(voice => voiceCardHtml(voice, '', '', imageLookup));
    if (quietFind) cards.push(voiceCardHtml(quietFind, 'Quiet find', 'Heard once this period', imageLookup));
    $('[data-fj-voices]', root).innerHTML = cards.length
      ? cards.join('')
      : '<div class="wpc-field-journal__empty">Details for this period are still being prepared.</div>';
  }

  function voiceCardHtml(voice, label, fallbackMeta, imageLookup) {
    const name = sourceLabel(voice) || 'Unidentified wildlife activity';
    const count = voice.detection_count ?? voice.detectionCount ?? voice.count ?? '';
    const hoursPresent = voice.hours_present ?? voice.hoursPresent ?? '';
    const meta = fallbackMeta || (hoursPresent ? `${hoursPresent} ${Number(hoursPresent) === 1 ? 'hour' : 'hours'} this period` : (count !== '' ? `${count} detections` : ''));
    const image = resolveSpeciesImage(voice, imageLookup);
    const audioUrl = resolveAudioUrl(voice.audio_url || voice.audioUrl || '');
    const button = audioUrl
      ? `<button class="wpc-field-journal__voice-button" type="button" data-fj-audio-url="${escapeHtml(audioUrl)}" data-fj-audio-name="${escapeHtml(name)}" aria-label="Play ${escapeHtml(name)} audio" aria-pressed="false">▶</button>`
      : '';
    return `<article class="wpc-field-journal__voice ${label ? 'wpc-field-journal__voice--quiet' : ''}">${label ? `<span class="wpc-field-journal__voice-label">${escapeHtml(label)}</span>` : ''}<span class="wpc-field-journal__voice-image">${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(name)}" loading="lazy">` : '<span aria-hidden="true">&#9834;</span>'}</span><b>${escapeHtml(name)}</b>${meta ? `<span>${escapeHtml(meta)}</span>` : ''}${button}</article>`;
  }

  function stateClassFor(status) {
    if (status === 'complete') return 'is-complete';
    if (status === 'observing' || status === 'finalizing') return 'is-current';
    if (status === 'incomplete') return 'is-incomplete';
    return 'is-upcoming';
  }

  function render(root, state) {
    const period = state.data.periods.find(item => samePeriodId(item.id, state.selectedPeriodId)) || state.data.periods[0];
    state.selectedPeriodId = period.id;
    root.setAttribute('data-current-period', period.id);
    renderTabs(root, state);
    renderPeriodSelect(root, state);
    renderHeader(root, state, period);
    $('[data-fj-period-title]', root).textContent = `${period.label} Journal`;
    $('[data-fj-period-range]', root).textContent = period.range;
    renderTimeline(root, period);
    renderGlance(root, period);
    renderWeather(root, period);
    renderEntries(root, period);
    renderVoices(root, period);
    renderNotice(root, state);
  }

  function renderNotice(root, state) {
    const notice = $('[data-fj-notice]', root);
    const message = state.message || '';
    notice.hidden = !message;
    notice.innerHTML = state.source === 'demo'
      ? `<strong>Preview data</strong><span>${escapeHtml(message)}</span>`
      : escapeHtml(message);
  }

  function removeLowerWeatherPanel(root) {
    const panel = $('[data-fj-weather-panel]', root)?.closest('.wpc-field-journal__panel');
    panel?.remove();
  }

  function initMenu(root) {
    const toggle = $('[data-fj-menu-toggle]', root);
    if (!toggle) return;
    toggle.addEventListener('click', () => {
      const isOpen = root.classList.toggle('is-menu-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
    $$('.wpc-field-journal__nav-link', root).forEach(link => {
      link.addEventListener('click', () => {
        root.classList.remove('is-menu-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  async function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    initMenu(root);
    removeLowerWeatherPanel(root);
    root.addEventListener('click', event => handleVoiceAudioClick(event, root));
    loadSpeciesImageLookup().then(lookup => {
      if (!root.isConnected) return;
      root._fieldJournalSpeciesImages = lookup;
      const state = root._fieldJournal;
      if (state) renderVoices(root, state.data.periods.find(item => samePeriodId(item.id, state.selectedPeriodId)) || state.data.periods[0]);
    });
    const result = await getData(root);
    const state = {
      data: result.data,
      selectedPeriodId: result.data.currentPeriod,
      message: result.message,
      source: result.source
    };
    root._fieldJournal = state;
    render(root, state);
  }

  function start() {
    document.querySelectorAll('[data-field-journal]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', event => {
    const root = event.target.matches?.('[data-field-journal]') ? event.target : event.target.querySelector?.('[data-field-journal]');
    if (!root) return;
    stopVoicePlayback(root);
    root._fieldJournalPlayback = null;
    root._fieldJournal = null;
  });
})();
